import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { HarloweSupport } from '@harlowe/core';
import { FileEditorComponent } from '../file-editor/file-editor.component';
import { UtilService } from '@harlowe/core';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ImageModule } from 'primeng/image';
import { AvatarModule } from 'primeng/avatar';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { FileUpload } from '../../../services/encounter.service';

@Component({
  selector: 'app-file-list',
  standalone: true,
  imports: [FileEditorComponent, PanelModule, ButtonModule, OverlayPanelModule,TableModule,
            FileUploadModule, NgFor, FormsModule,InputTextModule,AsyncPipe,ImageModule, AvatarModule,
            NgIf, FloatLabelModule, DropdownModule
  ],
  templateUrl: './file-list.component.html',
  styleUrl: './file-list.component.scss'
})
export class FileListComponent 
{
  // @Input() set files(value: HarloweSupport.File[])
  // {
  //   this._files = value ?? [];
  //   this.cdr.markForCheck();
  // }
  // get files(): HarloweSupport.File[]
  // {
  //   return this._files;
  // }
  // private _files: HarloweSupport.File[] = [];
  @Input() files:HarloweSupport.File[] = [];

  @Input() uploader?: IUploadProcessor;
  get sortedFiles() : HarloweSupport.File[]
  {
    var sortedVals = (this.files ?? [] as HarloweSupport.File[]).toSorted((a,b) => b.fileName > a.fileName ? 1 : 0);
    return sortedVals;
  }

  @Input() title: string = "Attachments";
  @Output() modified: EventEmitter<HarloweSupport.File[]> = new EventEmitter<HarloweSupport.File[]>();
  

  uploadCategories:string[] = 
  [
    'MedicalBill',
    'MedicalRecord',
    'Referral',
    'FNOL',
    'System'
  ]


  constructor(private _utilService:UtilService)
  {

  }

  isImage(file: File): boolean 
  {
    return /^image\//.test(file.type);
  }

  isPdf(file: File): boolean 
  {
    return /\/pdf/.test(file.type);
  }

  isOther(file: File): boolean
  {
    return !this.isImage(file) && !this.isPdf(file) && !this.isZip(file);
  }

  isZip(file:File) : boolean
  {
    return /\/x-zip/.test(file.type);
  }

  filesReady(files:File[]) : boolean
  {
    return files && files.length > 0 && files.every(f => (f as FileUpload).category != null)
  }


  getFileType(file:File):string
  {
    if(this.isPdf(file))
      return "PDF";
    if(this.isImage(file))
      return file.type.split("/")[1].toUpperCase();
    if(this.isZip(file))
      return "ZIP";
    else
      return "UNKNOWN";
  }





  async viewAttachment(file:HarloweSupport.File)
  {
    var blob = await this._utilService.getFileBlob(file);
    let url = window.URL.createObjectURL(blob);
      let pwa = window.open(url);
  }

  async uploadFiles(event:FileUploadHandlerEvent)
  {
    if(this.uploader)
    {
      var files: FileUpload[] = event.files;
      files.forEach(f => f.fileType = this.getFileType(f));
      var newFiles = await this.uploader.uploadFiles(files);
      this.modified.emit([...this.files, ...newFiles]);
    }
  }

  async deleteFile(file:HarloweSupport.File)
  {
    if(this.uploader)
    {
      var deletedFile = await this.uploader.deleteFile(file);
      this.modified.emit([...this.files.filter(f => f.id != deletedFile.id)])
    }
  }
}


export interface IUploadProcessor
{
  uploadFiles(files:FileUpload[]):Promise<HarloweSupport.File[]>;
  deleteFile(file:HarloweSupport.File):Promise<HarloweSupport.File>;
}


